import { z } from 'zod';
import { SchemaPassword } from '@axiom/types';

export const PasswordFormSchema = z.object({
  password: SchemaPassword,
});

export type PasswordFormData = z.infer<typeof PasswordFormSchema>;
